import { Component, OnInit, Input } from '@angular/core';
import * as _ from "lodash";

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {

  message: string = "";
  showC: boolean = false;
  time: any = 4;
  type: string = '';
  types: string[] = ['success', 'info', 'warning', 'danger'];

  /**
   * success,info,warning,danger
   */

  constructor() { }

  ngOnInit() {
  }

  show(msj, type) {
    this.showC = true;
    this.message = msj ? msj : "";
    this.type = type && _.includes(this.types, type) ? type : "info";
    //auto-close
    setTimeout(() => {
      this.showC = false;
    }, 1000 * this.time);
  }
  onClose() {
    this.showC = false;
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/alert/alert.component.ts